import { Injectable } from "@angular/core";
import { AngularFirestore } from "angularfire2/firestore";
import { API_ENDPOINTS } from "./api-endpoints";
import axios, { AxiosError, AxiosResponse } from "axios";

@Injectable({
  providedIn: "root",
})
export class ChargerService {
  constructor(private afs: AngularFirestore) {}

  async createCharger(payload) {
    return await new Promise((resolve, reject) => {
      axios
        .request({
          method: "post",
          url: `${API_ENDPOINTS.charger.createCharger}`,
          data: payload,
        })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async updateCharger(payload, chargerId) {
    return await new Promise((resolve, reject) => {
      axios
        .request({
          method: "patch",
          url: `${API_ENDPOINTS.charger.updateCharger}/${chargerId}`,
          data: payload,
        })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async deleteCharger(chargerId: string) {
    return await new Promise((resolve, reject) => {
      axios
        .request({
          method: "delete",
          url: `${API_ENDPOINTS.charger.deleteCharger}/${chargerId}`,
        })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async getAllCharger(offset = 0, limit = 100000, selectedChargerId?, selectedDriverId?) {
    let URL =
      `${API_ENDPOINTS.charger.getAllChargers}?limit=${limit}&offset=` +
      `${offset}`;
    if (selectedChargerId) {
      URL = URL + `&chargerId=${selectedChargerId}`;
    }
    if (selectedDriverId) {
      URL = URL + `&driverId=${selectedDriverId}`;
    }
    return await new Promise((resolve, reject) => {
      axios
        .request({
          method: "get",
          url: URL,
        })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async getListOfChargerIds() {
    return await new Promise((resolve, reject) => {
      axios
        .request({
          method: "get",
          url: `${API_ENDPOINTS.charger.getListOfChargerIds}`,
        })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async getListOfDriverIds() {
    return await new Promise((resolve, reject) => {
      axios
        .request({
          method: "get",
          url: `${API_ENDPOINTS.driver.getListOfDriverIds}`,
        })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }
}
